function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str?.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
}

export function getSectorColor(sector: string): string {
  const hash = hashString(sector?.toUpperCase());

  const hue = hash % 360;
  const saturation = 60 + ((hash >> 8) % 25);
  const lightness = 40 + ((hash >> 16) % 30);

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
